import React from "react";
import TextInfo, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_DECORATION,
  TEXT_DISPLAY,
} from "@gc-npm/components.text";
import Price, { PRICE_SIZE } from "@gc-npm/components.price";

import { getDurationPromoText, scrollToSection } from "@/utils/index";

const ShoppingCartModuleList = ({ modulos, isLoading }) => {
  if (!modulos || !modulos.items || !Array.isArray(modulos.items)) {
    return null;
  }

  const modulesKeys = Object.keys(modulos);

  const taggingInfo = {
    componentName: "ShoppingCart",
    componentProduct: "",
    componentContent: "",
    componentVariation: "",
  };
  return (
    <div className="ShoppingCartModuleList">
      {modulesKeys.map((section) => {
        if (
          modulos[section] &&
          modulos[section].items &&
          Array.isArray(modulos[section].items)
        ) {
          const { emptyTitle, emptyText } = modulos[section];
          const visibleItems = modulos[section].items.filter(
            ({ quantity }) => quantity !== 0
          );
          let emptySection = false;
          let items2Unsubscribe = null;
          if (visibleItems.length === 0) {
            emptySection = true;
          } else {
            items2Unsubscribe = visibleItems.filter(
              (item) => item.unsubscribe
            );
          }
          return (
            <div className="section" key={section}>
              <div className="category">
                <div className="info">
                  {emptySection && (
                    <div className="items">
                      <div className="item">
                        <TextInfo text={emptyText} color={TEXT_COLOR.GREY6} />
                        <TextInfo text={emptyTitle} color={TEXT_COLOR.GREY6} />
                      </div>
                    </div>
                  )}
                  {!emptySection && (
                    <div className="items">
                      {visibleItems.map(
                        ({
                          id,
                          title: moduleTitle,
                          price,
                          prices,
                          promoPrice,
                          promotions,
                          unsubscribe,
                          quantity,
                          text3,
                          promoDuration
                        }) => {
                          if (!unsubscribe) {
                            const promotionText = promoDuration;
                            const installationPromoPrice =
                              prices?.installationPrices?.promoPrice !==
                              prices?.installationPrices?.price
                                ? prices.installationPrices.promoPrice
                                : null;
                            const installationPrice =
                              prices?.installationPrices?.price;
                            const isSamePrice =
                              typeof price?.price === "number" &&
                              typeof promoPrice?.price === "number" &&
                              price.price === promoPrice.price;
                            return (
                              <div className="item" key={id}>
                                <div className="itemSection">
                                  <div
                                    className={`itemTitle ${isLoading ? "skeleton" : ""}`}
                                  >
                                    <TextInfo
                                      text={`${typeof quantity === "number" && quantity > 1 ? `${quantity}x ` : ""}${moduleTitle.text}`}
                                      size={TEXT_SIZE.BODY1}
                                      color={TEXT_COLOR.GREY6}
                                      kind={TEXT_KIND.PARAGRAPH}
                                      fontType={TEXT_FONT_WEIGHT.REGULAR}
                                      display={TEXT_DISPLAY.INLINE}
                                    />
                                  </div>
                                  <div
                                    className={`itemPrice ${isLoading ? "skeleton" : ""}`}
                                  >
                                    {!unsubscribe &&
                                      promoPrice &&
                                      price &&
                                      typeof price.price === "number" && (
                                        <Price
                                          price={price.price}
                                          color={
                                            (typeof promoPrice?.price === "number" && !isSamePrice)
                                              ? TEXT_COLOR.GREY5
                                              : TEXT_COLOR.MOVISTAR_BLACK
                                          }
                                          currency="€"
                                          size={PRICE_SIZE.XS}
                                          quote="mes"
                                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                                          decoration={
                                           (typeof promoPrice?.price === "number" && !isSamePrice)
                                              ? TEXT_DECORATION.LINE_THROUGH
                                              : TEXT_DECORATION.NONE
                                          }
                                        />
                                      )}
                                  </div>
                                </div>

                                {promoPrice && typeof promoPrice.price === "number" && !isSamePrice && (
                                    <div className="itemSection">
                                      <div className={`itemTitle ${isLoading ? "skeleton" : ""}`}>
                                        <TextInfo 
                                          text={promotionText}
                                          size={TEXT_SIZE.BODY1}
                                          color={TEXT_COLOR.RED_DARK}
                                          kind={TEXT_KIND.PARAGRAPH}
                                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                                        />
                                      </div>
                                      <div className={`itemPrice ${isLoading ? "skeleton" : ""}`}>
                                        <Price
                                          price={promoPrice.price}
                                          color={TEXT_COLOR.RED_DARK}
                                          currency="€"
                                          size={PRICE_SIZE.XS}
                                          quote="mes"
                                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                                        />
                                      </div>
                                    </div>
                                  )}
                                {prices &&
                                  text3?.text &&
                                  (typeof installationPrice === "number" ||
                                    typeof installationPromoPrice ===
                                      "number") && (
                                    <div className="itemSection">
                                      <div className={`itemTitle ${isLoading ? "skeleton" : ""}`}>
                                        <TextInfo
                                          text={text3?.text}
                                          size={TEXT_SIZE.BODY1}
                                          color={
                                            installationPromoPrice
                                              ? TEXT_COLOR.RED_DARK
                                              : TEXT_COLOR.GREY5
                                          }
                                          kind={TEXT_KIND.PARAGRAPH}
                                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                                        />
                                      </div>
                                      <div className={`itemPrice ${isLoading ? "skeleton" : ""}`}>
                                        <Price
                                          price={
                                            installationPromoPrice ||
                                            installationPrice
                                          }
                                          color={
                                            installationPromoPrice
                                              ? TEXT_COLOR.RED_DARK
                                              : TEXT_COLOR.GREY5
                                          }
                                          currency="€"
                                          size={PRICE_SIZE.XS}
                                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                                        />
                                      </div>
                                    </div>
                                  )}
                              </div>
                            );
                          }
                          return null;
                        }
                      )}
                    </div>
                  )}
                  {items2Unsubscribe && (
                    <div className="items items2Unsubscribe">
                      {items2Unsubscribe.map(
                        ({ id, title: moduleTitle, unsubscribe }) => {
                          return (
                            <div className="item" key={id}>
                              <div className="itemSection">
                                <div
                                  className={`itemTitle ${isLoading ? "skeleton" : ""}`}
                                >
                                  <TextInfo
                                    text={moduleTitle.text}
                                    size={TEXT_SIZE.BODY1}
                                    color={TEXT_COLOR.GREY6}
                                    kind={TEXT_KIND.PARAGRAPH}
                                    fontType={TEXT_FONT_WEIGHT.REGULAR}
                                  />
                                </div>
                                <div
                                  className={`itemPrice ${isLoading ? "skeleton" : ""}`}
                                >
                                  {unsubscribe && (
                                    <TextInfo
                                      text={unsubscribe}
                                      size={TEXT_SIZE.BODY1}
                                      color={TEXT_COLOR.MOVISTAR_BLACK}
                                      kind={TEXT_KIND.PARAGRAPH}
                                      fontType={TEXT_FONT_WEIGHT.REGULAR}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        }
        return null;
      })}
      <style jsx>
        {`
          .ShoppingCartModuleList {
            display: flex;
            flex-direction: column;
          }
          .section {
            display: flex;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
          }
          .category {
            padding-bottom: 1rem;
            display: flex;
            gap: 0.5rem;
            width: 100%;
          }
          .info {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }
          .items {
            display: flex;
            flex-direction: column;
            gap: 0;
            .item {
              .fakeItem {
                width: fit-content;
              }
            }
          }

          .itemSection {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            width: 100%;
            gap: 0.5rem;
          }
          .itemTitle {
            max-width: 70%;
            flex-grow: 1; /* Ocupa todo el espacio disponible */
            text-align: left;
            overflow: hidden; /* Evita que se salga del contenedor */
            text-overflow: ellipsis; /* Agrega "..." si el texto es demasiado largo */
          }
          .itemTitle :global(p) {
            margin: 0;
          }
          .itemPrice {
            white-space: nowrap; /* Evita saltos de línea */
            text-align: right;
            margin-left: auto; /* Empuja el precio completamente a la derecha */
          }
        `}
      </style>
    </div>
  );
};

export default ShoppingCartModuleList;
